import { render, staticRenderFns } from "./Transliteration.vue?vue&type=template&id=60a48d13"
import script from "./Transliteration.vue?vue&type=script&lang=js"
export * from "./Transliteration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports